export default "__VITE_ASSET__D70SmyF1__"